export default function makeDependencies(tools, language) {
    var InputField = getInputField()(tools.uniqueId);
    var validators = require('form/validators')(language);

    return {
        InputField,
        makeErrors,
        tools,
        validators,
        language
    };
}

function getInputField() {
    // return require('form/SimpleField.jsx');
    if (!isAndroid(navigator)) {
        return require('form/ComplexField.jsx').default;
    }
    else return require('form/SimpleField.jsx').default;
}

function makeErrors(errors, showErrors = true) {
    if (showErrors) return errors.slice(0,1).map((error, index) => {
        if (error) {
            return (
                <div className="lz-error" key={index}>
                    <span>{error}</span>
                </div>
            );
        }
    });
    else return null;
}

function supportsViewportUnits() {
    try {
        var el = document.createElement('dummy');
        el.style.width = "1vw";
        var test = el.style.width !== "";
        return !!test;
    } catch(err) {
        return false;
    }
}

function isAndroid({userAgent, vendor}) {
    return userAgent.match(/android/i);
}

function isSafari({userAgent, vendor}) {
    return userAgent.match(/safari/i) && vendor.match(/apple/i);
}
